import { createOutlineIcon } from "./iconCore"

import AlertCircleSvg from "./icons/alert-circle.svg"
import AlertTriangleSvg from "./icons/alert-triangle.svg"
import AnnouncementSvg from "./icons/announcement.svg"
import ArchiveSvg from "./icons/archive.svg"
import ArrowDownSvg from "./icons/arrow-down.svg"
import ArrowLeftSvg from "./icons/arrow-left.svg"
import ArrowRightSvg from "./icons/arrow-right.svg"
import ArrowUpSvg from "./icons/arrow-up.svg"
import ArrowUpRightSvg from "./icons/arrow-up-right.svg"
import AtSignSvg from "./icons/at-sign.svg"
import AudienceSvg from "./icons/audience.svg"
import BarChartSvg from "./icons/bar-chart.svg"
import BeakerSvg from "./icons/beaker.svg"
import BellSvg from "./icons/bell.svg"
import BrushSvg from "./icons/brush.svg"
import BugSvg from "./icons/bug.svg"
import CameraOffSvg from "./icons/camera-off.svg"
import CameraSvg from "./icons/camera.svg"
import CartAddSvg from "./icons/cart-add.svg"
import CartSvg from "./icons/cart.svg"
import ChartSvg from "./icons/chart.svg"
import ChatOffSvg from "./icons/chat-off.svg"
import ChatSvg from "./icons/chat.svg"
import CheckCircleSvg from "./icons/check-circle.svg"
import CheckVerifiedSvg from "./icons/check-verified.svg"
import CheckSvg from "./icons/check.svg"
import ChevronDownSvg from "./icons/chevron-down.svg"
import ChevronLeftSvg from "./icons/chevron-left.svg"
import ChevronRightSvg from "./icons/chevron-right.svg"
import ChevronUpSvg from "./icons/chevron-up.svg"
import ClosedCaptionSvg from "./icons/closed-caption.svg"
import CircleSvg from "./icons/circle.svg"
import ClapperBoardSvg from "./icons/clapper-board.svg"
import ClipboardCheckSvg from "./icons/clipboard-check.svg"
import ClipboardSvg from "./icons/clipboard.svg"
import CloseSvg from "./icons/close.svg"
import CodeSvg from "./icons/code.svg"
import CopySvg from "./icons/copy.svg"
import CreditCardSvg from "./icons/credit-card.svg"
import CrownSvg from "./icons/crown.svg"
import DotsVerticalSvg from "./icons/dots-vertical.svg"
import DownloadSvg from "./icons/download.svg"
import DragHandleSvg from "./icons/drag-handle.svg"
import EditSvg from "./icons/edit.svg"
import EyeOffSvg from "./icons/eye-off.svg"
import EyeSvg from "./icons/eye.svg"
import FaceHappySvg from "./icons/face-happy.svg"
import FaceSmileSvg from "./icons/face-smile.svg"
import FileSvg from "./icons/file.svg"
import FilmSvg from "./icons/film.svg"
import FilterFunnelSvg from "./icons/filter-funnel.svg"
import FlashSvg from "./icons/flash.svg"
import GiftSvg from "./icons/gift.svg"
import GraduationHatSvg from "./icons/graduation-hat.svg"
import HashSvg from "./icons/hash.svg"
import HelpCircleSvg from "./icons/help-circle.svg"
import HomeSvg from "./icons/home.svg"
import ImageSvg from "./icons/image.svg"
import InfoCircleSvg from "./icons/info-circle.svg"
import LayoutSvg from "./icons/layout.svg"
import LifeBuoySvg from "./icons/life-buoy.svg"
import LinkSvg from "./icons/link.svg"
import LinkExternalSvg from "./icons/link-external.svg"
import LockUnlockedSvg from "./icons/lock-unlocked.svg"
import LockSvg from "./icons/lock.svg"
import LogOutSvg from "./icons/log-out.svg"
import MailOpenSvg from "./icons/mail-open.svg"
import MailSvg from "./icons/mail.svg"
import MaximizeSvg from "./icons/maximize.svg"
import MenuSvg from "./icons/menu.svg"
import MicrophoneOffSvg from "./icons/microphone-off.svg"
import MicrophoneOnSvg from "./icons/microphone-on.svg"
import MinimizeSvg from "./icons/minimize.svg"
import MinusSvg from "./icons/minus.svg"
import MinusCircleSvg from "./icons/minus-circle.svg"
import PictureInPictureSvg from "./icons/picture-in-picture.svg"
import PinSvg from "./icons/pin.svg"
import PlayCircleSvg from "./icons/play-circle.svg"
import PlaySvg from "./icons/play.svg"
import PlayLoopSvg from "./icons/play-loop.svg"
import PlayOnceSvg from "./icons/play-once.svg"
import PlusSvg from "./icons/plus.svg"
import PlusCircleSvg from "./icons/plus-circle.svg"
import RefreshSvg from "./icons/refresh.svg"
import CompanionSvg from "./icons/companion.svg"
import SaleTagSvg from "./icons/sale-tag.svg"
import ScissorsSvg from "./icons/scissors.svg"
import ScreenShareSvg from "./icons/screen-share.svg"
import SearchPackageSvg from "./icons/search-package.svg"
import SearchSvg from "./icons/search.svg"
import SendSvg from "./icons/send.svg"
import SettingsSvg from "./icons/settings.svg"
import ShareSvg from "./icons/share.svg"
import SpeedometerSvg from "./icons/speedometer.svg"
import StackSvg from "./icons/stack.svg"
import StageSvg from "./icons/stage.svg"
import StarsSvg from "./icons/stars.svg"
import StickerCircleSvg from "./icons/sticker-circle.svg"
import StopCircleSvg from "./icons/stop-circle.svg"
import StudioSvg from "./icons/studio.svg"
import TrashSvg from "./icons/trash.svg"
import UserCheckSvg from "./icons/user-check.svg"
import UserCircleSvg from "./icons/user-circle.svg"
import UserPlusSvg from "./icons/user-plus.svg"
import UserXSvg from "./icons/user-x.svg"
import UserSvg from "./icons/user.svg"
import VideoOffSvg from "./icons/video-off.svg"
import VideoSvg from "./icons/video.svg"
import VolumeOffSvg from "./icons/volume-off.svg"
import VolumeOnSvg from "./icons/volume-on.svg"
import VolumeXSvg from "./icons/volume-x.svg"

export const AlertCircle = createOutlineIcon(AlertCircleSvg, "Alert")
export const AlertTriangle = createOutlineIcon(AlertTriangleSvg, "Alert")
export const Announcement = createOutlineIcon(AnnouncementSvg, "Announcement")
export const Archive = createOutlineIcon(ArchiveSvg, "Archive")
export const ArrowDown = createOutlineIcon(ArrowDownSvg, "Arrow Down")
export const ArrowLeft = createOutlineIcon(ArrowLeftSvg, "Arrow Left")
export const ArrowRight = createOutlineIcon(ArrowRightSvg, "Arrow Right")
export const ArrowUp = createOutlineIcon(ArrowUpSvg, "Arrow Up")
export const ArrowUpRight = createOutlineIcon(ArrowUpRightSvg, "Arrow Up Right")
export const AtSign = createOutlineIcon(AtSignSvg, "At Sign")
export const Audience = createOutlineIcon(AudienceSvg, "Audience")
export const BarChart = createOutlineIcon(BarChartSvg, "Bar Chart")
export const Beaker = createOutlineIcon(BeakerSvg, "Beaker")
export const Bell = createOutlineIcon(BellSvg, "Bell")
export const Brush = createOutlineIcon(BrushSvg, "Brush")
export const Bug = createOutlineIcon(BugSvg, "Bug")
export const CameraOff = createOutlineIcon(CameraOffSvg, "Camera Off")
export const Camera = createOutlineIcon(CameraSvg, "Camera")
export const CartAdd = createOutlineIcon(CartAddSvg, "Cart Add")
export const Cart = createOutlineIcon(CartSvg, "Cart")
export const Chart = createOutlineIcon(ChartSvg, "Chart")
export const ChatOff = createOutlineIcon(ChatOffSvg, "Chat Off")
export const Chat = createOutlineIcon(ChatSvg, "Chat")
export const CheckCircle = createOutlineIcon(CheckCircleSvg, "Check")
export const CheckVerified = createOutlineIcon(CheckVerifiedSvg, "Verified")
export const Check = createOutlineIcon(CheckSvg, "Check")
export const ChevronDown = createOutlineIcon(ChevronDownSvg, "Chevron Down")
export const ChevronLeft = createOutlineIcon(ChevronLeftSvg, "Chevron Left")
export const ChevronRight = createOutlineIcon(ChevronRightSvg, "Chevron Right")
export const ChevronUp = createOutlineIcon(ChevronUpSvg, "Chevron Up")
export const Circle = createOutlineIcon(CircleSvg, "Circle")
export const ClapperBoard = createOutlineIcon(ClapperBoardSvg, "Clapper Board")
export const ClipboardCheck = createOutlineIcon(
  ClipboardCheckSvg,
  "Clipboard Check",
)
export const Clipboard = createOutlineIcon(ClipboardSvg, "Clipboard")
export const Close = createOutlineIcon(CloseSvg, "Close")
export const ClosedCaption = createOutlineIcon(
  ClosedCaptionSvg,
  "Closed Captions",
)
export const Code = createOutlineIcon(CodeSvg, "Embed")
export const Copy = createOutlineIcon(CopySvg, "Copy")
export const CreditCard = createOutlineIcon(CreditCardSvg, "Credit Card")
export const Crown = createOutlineIcon(CrownSvg, "Crown")
export const DotsVertical = createOutlineIcon(DotsVerticalSvg, "Vertical Dots")
export const Download = createOutlineIcon(DownloadSvg, "Download")
export const DragHandle = createOutlineIcon(DragHandleSvg, "Drag")
export const Edit = createOutlineIcon(EditSvg, "Edit")
export const EyeOff = createOutlineIcon(EyeOffSvg, "Hide")
export const Eye = createOutlineIcon(EyeSvg, "Show")
export const FaceHappy = createOutlineIcon(FaceHappySvg, "Happy Face")
export const FaceSmile = createOutlineIcon(FaceSmileSvg, "Smiling Face")
export const File = createOutlineIcon(FileSvg, "File")
export const Film = createOutlineIcon(FilmSvg, "Film")
export const FilterFunnel = createOutlineIcon(FilterFunnelSvg, "Filter")
export const Flash = createOutlineIcon(FlashSvg, "Flash")
export const Gift = createOutlineIcon(GiftSvg, "Gift")
export const GraduationHat = createOutlineIcon(
  GraduationHatSvg,
  "Graduation Hat",
)
export const Hash = createOutlineIcon(HashSvg, "Hash")
export const HelpCircle = createOutlineIcon(HelpCircleSvg, "Help")
export const Home = createOutlineIcon(HomeSvg, "Home")
export const Image = createOutlineIcon(ImageSvg, "Image")
export const InfoCircle = createOutlineIcon(InfoCircleSvg, "Info")
export const Layout = createOutlineIcon(LayoutSvg, "Layout")
export const LifeBuoy = createOutlineIcon(LifeBuoySvg, "Life Buoy")
export const Link = createOutlineIcon(LinkSvg, "Link")
export const LinkExternal = createOutlineIcon(LinkExternalSvg, "External Link")
export const LockUnlocked = createOutlineIcon(LockUnlockedSvg, "Unlocked")
export const Lock = createOutlineIcon(LockSvg, "Lock")
export const LogOut = createOutlineIcon(LogOutSvg, "Log Out")
export const MailOpen = createOutlineIcon(MailOpenSvg, "Mail Open")
export const Mail = createOutlineIcon(MailSvg, "Mail")
export const Maximize = createOutlineIcon(MaximizeSvg, "Maximize")
export const Menu = createOutlineIcon(MenuSvg, "Menu")
export const MicrophoneOff = createOutlineIcon(
  MicrophoneOffSvg,
  "Microphone Off",
)
export const MicrophoneOn = createOutlineIcon(MicrophoneOnSvg, "Microphone On")
export const Minimize = createOutlineIcon(MinimizeSvg, "Minimize")
export const Minus = createOutlineIcon(MinusSvg, "Minus")
export const MinusCircle = createOutlineIcon(MinusCircleSvg, "Minus Circle")
export const PictureInPicture = createOutlineIcon(
  PictureInPictureSvg,
  "Picture In Picture",
)
export const Pin = createOutlineIcon(PinSvg, "Pin")
export const PlayCircle = createOutlineIcon(PlayCircleSvg, "Play Circle")
export const Play = createOutlineIcon(PlaySvg, "Play")
export const PlayLoop = createOutlineIcon(PlayLoopSvg, "Play Loop")
export const PlayOnce = createOutlineIcon(PlayOnceSvg, "Play Once")
export const Plus = createOutlineIcon(PlusSvg, "Plus")
export const PlusCircle = createOutlineIcon(PlusCircleSvg, "Plus Circle")
export const Refresh = createOutlineIcon(RefreshSvg, "Refresh")
export const Companion = createOutlineIcon(CompanionSvg, "Companion")
export const SaleTag = createOutlineIcon(SaleTagSvg, "Sale Tag")
export const Scissors = createOutlineIcon(ScissorsSvg, "Scissors")
export const ScreenShare = createOutlineIcon(ScreenShareSvg, "ScreenShare")
export const SearchPackage = createOutlineIcon(SearchPackageSvg, "Search")
export const Search = createOutlineIcon(SearchSvg, "Search")
export const Send = createOutlineIcon(SendSvg, "Send")
export const Settings = createOutlineIcon(SettingsSvg, "Settings")
export const Share = createOutlineIcon(ShareSvg, "Share")
export const Speedometer = createOutlineIcon(SpeedometerSvg, "Speedometer")
export const Stack = createOutlineIcon(StackSvg, "Stack")
export const Stage = createOutlineIcon(StageSvg, "Stage")
export const Stars = createOutlineIcon(StarsSvg, "Stars")
export const StickerCircle = createOutlineIcon(StickerCircleSvg, "Sticker")
export const StopCircle = createOutlineIcon(StopCircleSvg, "Stop")
export const Studio = createOutlineIcon(StudioSvg, "Studio")
export const Trash = createOutlineIcon(TrashSvg, "Trash")
export const UserCircle = createOutlineIcon(UserCircleSvg, "User")
export const UserCheck = createOutlineIcon(UserCheckSvg, "User")
export const UserPlus = createOutlineIcon(UserPlusSvg, "Add Guest")
export const UserX = createOutlineIcon(UserXSvg, "Banned User")
export const User = createOutlineIcon(UserSvg, "User")
export const VideoOff = createOutlineIcon(VideoOffSvg, "Video Off")
export const Video = createOutlineIcon(VideoSvg, "Video")
export const VolumeOff = createOutlineIcon(VolumeOffSvg, "Volume Off")
export const VolumeOn = createOutlineIcon(VolumeOnSvg, "Volume On")
export const VolumeX = createOutlineIcon(VolumeXSvg, "Volume Off")
